<script lang="ts" setup>
const { $preview } = useNuxtApp()
</script>

<template>
  <div class="epc-homepage-wide">
    <Header :hide="false" wide />
    <slot />
    <LazyFooter wide />
    <LazyNewPreview v-if="$preview" />
  </div>
</template>

<style>
.epc-homepage-wide {
  --epc-font-display: 'Neue Haas Grotesk Display', sans-serif;
  --epc-font-text: 'Neue Haas Grotesk Text', sans-serif;
  --epc-brand-blue: #002b40;
  --epc-brand-green: #6dbf44;
  --epc-surface: #f3f6f5;
}

.epc-homepage-wide > .header--wide > .header-primary > .header-primary__inner,
.epc-homepage-wide > .header--wide > div:first-child > .container {
  width: 100%;
  max-width: 1920px;
}

@media (min-width: 681px) {
  .epc-homepage-wide > .header--wide > .header-primary > .header-primary__inner,
  .epc-homepage-wide > .header--wide > div:first-child > .container {
    padding-inline: 48px;
  }
}
</style>
